import { Inject, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class GlobalColours {

  public static Map  = {
    'Job Ready': '#AEFFA1',
    "Prêt à l'emploi": '#AEFFA1',
    'Employment Prep': '#FFE999',
    "Préparation à l`emploi": '#FFE999',
    'Pre-Employment': '#FFA1B2',
    "Pré-emploi": '#FFA1B2',
    'Re-engagement': '#C9A1FF',
    "Réengagement": '#C9A1FF',
    'Retention': '#C39A4DFF',
    "Rétention": '#C39A4DFF',
    'In Skills Training': '#008080',
    'En formation de compétences': '#008080',
    'In Monitoring': '#0000ff',
    'En surveillance': '#0000ff'
  }
}

